"use client";
import { useEffect } from "react";
import { StorageUtils } from "../utils/StorageUtils";

export const SessionHandler = ({ browserSessionId }: { browserSessionId: string }) => {
    useEffect(() => {
        StorageUtils.setItem("browserSessionId", browserSessionId);
    }, [browserSessionId]);

    return null;
};
